import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-webapp-page',
  templateUrl: './webapp-page.component.html',
  styleUrls: ['./webapp-page.component.scss']
})
export class WebappPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
